import { IsEmail, IsNotEmpty, IsString } from '@pristine-ts/class-validator';
import { translationBaseKey } from '../decorators/translation-base-key.decorator';
import { ErrorMessageBuilder } from '../builders/error-message.builder';
import {advancedFormControl, FormControlTypeEnum} from "@magieno/common";

@translationBaseKey('organization-creation-options')
export class OrganizationCreationOptions {
  @IsEmail()
  email: string;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Nom de l\'entreprise',
        en: 'Organization name',
      },
    },
    type: FormControlTypeEnum.Input
  })
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  organizationName: string;
}
